import React from "react";
import logoMain from "../../Assets/images/logoMain.png";
import Header from "../header";

export default function LogoSection(props) {
  return (
    <Header quoteUrl={props?.bannnerData[0]?.content?.buttons[0]?.link_url}/>
  );
}
